import React, { useEffect, useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/footer/Footer";
import NormalHeader from "components/header/Normal/Header";
import UserHeader from "components/header/User/Header";
import Announcement from "pages/annoucement/Annoucement";
import CenterLanding from "pages/center-landing/CenterPage";
import CompareChosenCourse from "pages/course/CompareCourse";
import CourseDetails from "pages/course/CourseDetail";
import staticCourseRoutes from "./staticCourseRoutes";
import CourseListing from "pages/course/CourseListing";
import Login from "pages/forms/Login";
import ResetPassword from "pages/forms/RestPassword";
import SignUp from "pages/forms/SignUp";
import Articles from "pages/free-resources/articles/Articles";
import FreeResource from "pages/free-resources/FreeResource";
import ClasseSubject from "pages/free-resources/PDF-Notes/ClasseSubject";
import ClassesSubjectPdf from "pages/free-resources/PDF-Notes/ClasseSubjectPdf";
import DownloadCourse from "pages/free-resources/DownloadCourse";
import PDFNotes from "pages/free-resources/PDF-Notes/Notes";
import NewsArticlesDetail from "pages/free-resources/shubh-bharat/NewsArticlesDetail";
import NewsArticlesListing from "pages/free-resources/shubh-bharat/NewsArticlesListing";
import ShubhBharatTimes from "pages/free-resources/shubh-bharat/ShubhBharatTimes";
import VideoResource from "pages/free-resources/video-resource/VideoResource";
import Home from "pages/home/Home";
import OurStory from "pages/ourstory/OurStory";

import FreeResources from "../components/free-resources/FreeResources";

import FRAboutUPSC from "../components/free-resources/AboutUPSC/AboutUPSC";
import FRAboutUPSCContent from "../components/free-resources/AboutUPSC/Content";
import FRAboutUPSCEligibility from "../components/free-resources/AboutUPSC/Eligibility";

import FRPrelims from "../components/free-resources/Prelims/Prelims";
import FRPrelimsSyllabus from "../components/free-resources/Prelims/Syllabus";
import FRPrelimsPYQPrelims from "../components/free-resources/Prelims/PYQPrelims";
import FRPrelimsPrelimsStrategy from "../components/free-resources/Prelims/PrelimsStrategy";
import FRPrelimsHotTopicsforPrelims from "../components/free-resources/Prelims/HotTopicsforPrelims";

import FRMains from "../components/free-resources/Mains/Mains";
import FRMainsSyllabus from "../components/free-resources/Mains/Syllabus";
import FRMainsEssay from "../components/free-resources/Mains/Essay";
import FRMainsPYQMains from "../components/free-resources/Mains/PYQMains";
import FRMainsHotTopicsforMains from "../components/free-resources/Mains/HotTopicsforMains";
import FRMainsGS1 from "../components/free-resources/Mains/GS1/GS1";
import FRMainsGS1Notes from "../components/free-resources/Mains/GS1/GS1Notes";
import FRMainsGS2Notes from "../components/free-resources/Mains/GS2/GS2Notes";
import FRMainsGS3Notes from "../components/free-resources/Mains/GS3/GS3Notes";
import FRMainsGS4Notes from "../components/free-resources/Mains/GS4/GS4Notes";
import FRMainsGS1Overview from "../components/free-resources/Mains/GS1/GS1Overview";
import FRMainsGS2Overview from "../components/free-resources/Mains/GS2/GS2Overview";
import FRMainsGS3Overview from "../components/free-resources/Mains/GS3/GS3Overview";
import FRMainsGS4Overview from "../components/free-resources/Mains/GS4/GS4Overview";
import FRMainsGS2 from "../components/free-resources/Mains/GS2/GS2";
import FRMainsGS3 from "../components/free-resources/Mains/GS3/GS3";
import FRMainsGS4 from "../components/free-resources/Mains/GS4/GS4";
import FRMainsPSIR from "../components/free-resources/Mains/PSIR";
import FRMainsPSIRPaper1 from "../components/free-resources/Mains/PSIRpaper1";
import FRMainsPSIRPaper2 from "../components/free-resources/Mains/PSIRpaper2";

import FROptional from "../components/free-resources/Optional/Optional";
import FROptionalPSIR from "../components/free-resources/Optional/PSIR";
import FROptionalHistory from "../components/free-resources/Optional/History";
import FROptionalSociology from "../components/free-resources/Optional/Sociology";
import FROptionalGeography from "../components/free-resources/Optional/Geography";

import FRInterview from "../components/free-resources/Interview/Interview";
import FRInterviewToppersInterview from "../components/free-resources/Interview/ToppersInterview";
import FRInterviewTopInterviews from "../components/free-resources/Interview/TopInterviews";
import FRInterviewToppersList from "../components/free-resources/Interview/ToppersList";
import FRInterviewPanelList from "../components/free-resources/Interview/PanelList";

import Offline from "pages/Offline/Offline";
import TeacherProfile from "pages/teacher-profile/TeacherProfile";
import Workshop from "pages/workshop/Workshop";
import ArticlesPDFListing from "pages/free-resources/articles/ArticlesPDFListing";
import ToppersCopies from "pages/free-resources/toppers-copies/ToppersCopies";
import Magazines from "pages/free-resources/magazines/Magazine";
import Blogs from "pages/blogs/Blogs";
import BlogPost from "pages/blogs/BlogPost";
import BlogPostDetail from "pages/blogs/BlogPostDetail";
import DailyQuiz from "pages/free-resources/daily-quiz/DailyQuiz";
import PreviousPaper from "pages/free-resources/previous-paper/PreviousPaper";
import Dashboard from "dashboard/user-dashboard/Dashbaord";

import EditProfile from "dashboard/edit-profile/EditProfile";
import AppointmentBookingType from "dashboard/mentor-book-appointment/AppointmentBookingType";
import StudentMentorshipForm from "dashboard/mentor-book-appointment/StudentMentorshipForm";
import MentorSelection from "dashboard/mentor-book-appointment/MentorSelection";
import UpdateUserProfile from "dashboard/edit-profile/UpdateUserProfile";
import UpdateKYCDetails from "dashboard/edit-profile/UpdateKYCDetails";
import Lecture from "dashboard/lecture/Lecture";
import TestSeries from "dashboard/test-series/TestSeries";
import SubjectPage from "pages/subject-page/SubjectPage";
import TermsCondition from "pages/other-pages/TermsCondition";
import PrivacyPolicy from "pages/other-pages/PrivacyPolicy";
import FAQPage from "pages/other-pages/FAQPage";
import CourseSubscription from "pages/course-subscription/CourseSubscription";
import { isLoggedIn } from "config/utils";
import LectureVideo from "dashboard/lecture/lecture-video/LectureVideo";
import ThankYou from "pages/ThankYou/ThankYou";
import ContactThankYou from "pages/ThankYou/ContactUsThankYou";
import TestPage from "dashboard/test-series/testPage/TestPage";
import TestUnit from "dashboard/test-series/test/TestUnit";
import TestResultSummery from "dashboard/test-series/testPage/TestResultSummery";
import ShubhraMadam from "pages/teacher-profile/ShubharaMadam";
import PaymentSuccess from "pages/payment-msg/PaymentSuccess";
import PaymentFailed from "pages/payment-msg/PaymentFailed";
import EnquiryForm from "components/enquiry-form/EnquiryForm";
import Implementscript from "components/implementscript/Implementscript";
import LiveLectureVideo from "dashboard/liveLecture/LiveLectureVideo";
import Success from "pages/payment-msg/Success";
import Failed from "pages/payment-msg/Failed";
import OnDemandLectureDetail from "dashboard/lecture/on-demand/OnDemandLectureDetail";
import CourseReport from "dashboard/course-report/CourseReport";
import ReUploadAnswerSheet from "dashboard/reupload-answer-sheet/ReUploadAnswerSheet";
import MyAppointments from "dashboard/mentor-book-appointment/MyAppointments";
import AppointmentDetailPage from "dashboard/mentor-book-appointment/sub/AppointmentDetailPage";
import ViewMentorStudentDetails from "dashboard/mentor-book-appointment/sub/ViewStudentDetails";
import UpcomingAppointments from "dashboard/mentor-book-appointment/UpcomingAppointments";
import PostalCourseListing from "dashboard/postal-course-document/PostalFolder";
import PostalCourseSubListing from "dashboard/postal-course-document/PostalFile";
import PostalFolderList from "dashboard/postal-course-document/PostalFolder";
import NotFound from "pages/not-found/NotFound";
import { OnDemandViewedList } from "services/lecture";
import OnDemandUpcomingList from "dashboard/lecture/on-demand/section/OnDemandUpcomingList";
import DeleteAccount from "pages/other-pages/DeleteAccount";

import ICICIresponse from "pages/icici-response/ICICIresponse";


import OurToppers from "dashboard/our-toppers/OurToppers";
import MyToken from "pages/GenerateToken/MyToken";
import PaymentLinkSubscription from "pages/PaymentLinkSubs/PaymentLinkSubscription";
import PaymentLinkExpired from "pages/PaymentLinkSubs/PaymentLinkExpired";
import LectureByNotesNew from "dashboard/lecture/Section/LectureByNotesNew";
//import { Freeresources } from "assets/images";
// import ApexLecture from "../../src/components/video-player/ApexLecture";
import DownloadSolution from "pages/downloadSolution/DownloadSolution";
import NewPage from "pages/NewPage/NewPage";
import NewPage2 from "pages/CourseEnquiry/CourseEnquiiry";
import StudentCoursePayments from "pages/StudentCoursePayements/StudentCoursePayments";
import StudentCoursePaymentRefunds from "pages/studentCourseRefunds/StudentCoursePaymentRefunds";
import VerifyStudentAccountDetails from "pages/studentCourseRefunds/sub/VerifyStudentAccountDetails";
import {
  PSIRRedirect,
  GSFoundationOnlineCourseRedirect,
  GSFoundationClassroomCourseRedirect,
  SociologyOptionalClassroomCourseRedirect,
  PSIROptionalClassroomCourseRedirect,
  PoliticalScienceInternationalRelationsTabletCourseRedirect,
  PsirOptionalClassroomCourseRedirect,
  IASInstitutePuneRedirect,
  PSIRWritingMentorShip,
} from "./PSIRRedirect";
import TopperNavigator from "./TopperNavigator";
import NewOurToppers from "dashboard/our-toppers/NewOurToppers";
import N2 from "pages/NewPage/N2/N2";
import CivilServiceProgram from "pages/civilserviceprogram/CivilServiceProgram";
import BlocksPageofCategory from "pages/blogs/BlogPostofCategory";
import BlogDetailPreview from "pages/blogs/BlogDetailPreview";
import BlocksPageofCreator from "pages/blogs/BlogPostofCreator";
import MentorShipCourseSelection from "dashboard/mentor-book-appointment/sub/MentorCourseSelection";
import CityWisePage from "pages/citywisepages/CityWisePages";
import NewPostalFolderList from "dashboard/postal-course-document/NewPostalFolder";
import NewPostalFileListing from "dashboard/postal-course-document/NewPostalFile";
import WelcomeMentorshipPage from "dashboard/mentor-book-appointment/welcomementor/WelcomeMentorship";
import LectureLayout from "dashboard/lecture/PersonalizedLectures/PesonalizedLectureLayout";
import PersonalizedLectureVideo from "dashboard/lecture/PersonalizedLectures/PlayPersonalizedVideo/PersonalizedVideo";
import BhagwanMishra from "pages/teacher-profile/BhagwanMishra";
import BharatKhatal from "pages/teacher-profile/BharatKhatal";
import VishnuVardhan from "pages/teacher-profile/VishnuVardhan";
import QrCourse from "pages/qrCourses/qrCourse";
import QrCode from "pages/qrCode/qrCode";
import GSPrelimscumMainsOnlineCourse from "pages/coursepages/GSPrelimscumMainsOnlineCourse";

// import Sample from "pages/sample/sample";

//protected routes
const ProtectedRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  } else {
    return children;
  }
};

const NormalHeaderOutlet = () => {
  return (
    <>
      <div>
        <NormalHeader />
        <Outlet />
        {/* button for enquiry */}
        <EnquiryForm />

        <Implementscript />
        <Footer />
      </div>
    </>
  );
};

const NormalHeaderwithoutFooterOutlet = () => {
  return (
    <>
      <div>
        <NormalHeader />
        <Outlet />
        {/* button for enquiry */}
        <EnquiryForm />

        <Implementscript />
      </div>
    </>
  );
};

const UserHeaderOutlet = ({ courseDrawerShow, setCourseDrawerShow }) => {
  return (
    <>
      <div>
        <UserHeader
          courseDrawerShow={courseDrawerShow}
          setCourseDrawerShow={setCourseDrawerShow}
        />
        <Outlet />
        {/* <Footer /> */}
      </div>
    </>
  );
};

const WithoutHeader = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

const Routing = () => {
  const [courseDrawerShow, setCourseDrawerShow] = useState(false);
  const location = useLocation();
  const [centerflag, setcenterflag] = useState(false);
  useEffect(() => {
    if (location?.pathname.includes("IAS")) {
      setcenterflag(true);
    } else {
      setcenterflag(false);
    }
  }, [location]);
  return (
    <section className="routing">
      <Routes basename="/">
        {/* normal Header routes */}
        <Route exact path="/" element={<NormalHeaderOutlet />}>
          <Route path="*" element={<NotFound />} />
          <Route path="/qr-course/:courseId" element={<QrCourse />} />
          <Route path="/qr-scan/:qrcode" element={<QrCode />} />
          <Route path="/qr-details" element={<QrCode />} />
          <Route path="/" element={<Home />} />
          <Route path={`/""`} element={<IASInstitutePuneRedirect />} />
          <Route path={`/''`} element={<IASInstitutePuneRedirect />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/sample" element={<Sample />} /> */}
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/welcome-to-mentorship"
            element={<WelcomeMentorshipPage />}
          />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          {/* <Route
            path="/:centerName/:type/:centerId"
            element={<CenterLanding />}
          /> */}
          {centerflag ? (
            <Route path="/:centerId" element={<CenterLanding />} />
          ) : (
            <Route path="/:city" element={<CityWisePage />} />
          )}

          <Route
            path="/course-listing/:type?/:categoryName?/:categoryId?/:subCategoryName?/:subCategoryId?"
            element={<CourseListing />}
          />
          <Route path="/teacher/:name/:id" element={<TeacherProfile />} />
          <Route
            path="/teacher/bhagwan-prasad-mishra"
            element={<BhagwanMishra />}
          />
          <Route path="/teacher/bharat-khatal" element={<BharatKhatal />} />
          <Route path="/teacher/vishnu-vardhan" element={<VishnuVardhan />} />
          <Route
            path="/course-detail/:name/:id/:centerid?"
            element={<CourseDetails />}
          />
          <Route path="/daily-quiz" element={<DailyQuiz />} />
          <Route path="/ourstory" element={<OurStory />} />
          <Route exact path="/toppers-copies" element={<NewOurToppers />} />
          <Route path="/offline" element={<Offline />} />

          <Route path="/my-token" element={<MyToken />} />
          <Route
            path="icici-transaction-response"
            element={<ICICIresponse />}
          />
          <Route path="terms-and-condition" element={<TermsCondition />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faqs" element={<FAQPage />} />
          {/* <Route path="/delete-account" element={<DeleteAccount/>}/> */}

          <Route path="/thank-you" element={<ThankYou />} />
          {/* ******************************** Contact Us Thank You *************************************** */}
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/contact-thank-you" element={<ContactThankYou />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/success" element={<Success />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/failed" element={<Failed />} />
          <Route
            path="/affiliate-payment-link/:btransactionid/:admissionid"
            element={<PaymentLinkSubscription />}
          />
          <Route
            path="/payment-link-expired"
            element={<PaymentLinkExpired />}
          />

          <Route
            path="/courses/psir-courses/psir-optional-classroom-course"
            element={<PsirOptionalClassroomCourseRedirect />}
          />
          {/* <Route path="/courses/psir-courses/psir-optional-classroom-course" element={<PoliticalScienceandInternationalRelationsClassroomCourse6MonthsTarget2026 />} /> */}
          {/* <Route path="/courses/psir-courses/psir-answer-writing-module?utm_source" element={<PSIRWritingMentorShip/>}/> */}
          {/* <Route path="/courses/psir-courses/psir-optional-online-course" element={<PoliticalScienceandInternationalRelationsTabletCourse6MonthsTarget2026 />} /> */}
          <Route
            path="/courses/psir-courses/psir-postal-correspondence-course"
            element={<PSIRRedirect />}
          />
          <Route
            path="/gs-foundation-online-course"
            element={<GSFoundationOnlineCourseRedirect />}
          />
          <Route
            path="/gs-foundation-classroom-course"
            element={<GSFoundationClassroomCourseRedirect />}
          />

          <Route
            path="/courses/psir-courses/psir-optional-online-course"
            element={
              <PoliticalScienceInternationalRelationsTabletCourseRedirect />
            }
          />

          <Route
            path="/psir-optional-classroom-course"
            element={<PSIROptionalClassroomCourseRedirect />}
          />
          <Route
            path="/sociology-optional-classroom-course"
            element={<SociologyOptionalClassroomCourseRedirect />}
          />

          <Route path="/courses/gs-courses/gs-foundation-online-course" element={<GSPrelimscumMainsOnlineCourse />} />
          {/* <Route
            path="/courses/gs-courses/gs-foundation-online-course"
            element={<GSFoundationOnlineCourseRedirect />}
          /> */}



          {/* // Blog Pages */}
          <Route path="/blog-post" element={<BlogPost />} />
          <Route
            path="/blog-post-detail/:postid?"
            element={<BlogPostDetail />}
          />
          <Route path="/blog/:postid?" element={<BlogPostDetail />} />
          <Route
            path="/blog-post-preview/:postid?"
            element={<BlogDetailPreview />}
          />
          <Route
            path="/blog-posts/:categoryid?/:categoryname?"
            element={<BlocksPageofCategory />}
          />
          <Route
            path="/blog-posts-by/:addedbyid?/:addedbyname?"
            element={<BlocksPageofCreator />}
          />

          {/* <Route path="/courses/gs-courses/qep-gs-crash-course-online" element={<IntegratedGSandPSIROptionalClassroomCourse />} />
           */}

          {/* <Route path="/compare-course" element={<CompareChosenCourse />} /> */}
          {/* <Route path="/teacher/shubhra-madam" element={<ShubhraMadam />} />
          <Route path="/free-resources" element={<FreeResource />} />
          <Route path="/free-resources/pdfnotes" element={<PDFNotes />} />
          <Route
            path="/free-resources/pdfnotes/class-subjects"
            element={<ClasseSubject />}
          />
          <Route
            path="/free-resources/pdfnotes/class-subjects/subjectpdf"
            element={<ClassesSubjectPdf />}
          />
          <Route
            path="/free-resources/pdfnotes/class-subjects/subjectpdf/download"
            element={<DownloadCourse />}
          />
          <Route path="/free-resources/videos" element={<VideoResource />} />
          <Route
            path="/free-resources/bhubhbharat-times"
            element={<ShubhBharatTimes />}
          />
          <Route
            path="/free-resources/bhubhbharat-times/listing"
            element={<NewsArticlesListing />}
          />
          <Route
            path="/free-resources/bhubhbharat-times/listing/detail"
            element={<NewsArticlesDetail />}
          />
          <Route path="/free-resources/articles" element={<Articles />} />
          <Route
            path="/free-resources/articles/listing"
            element={<ArticlesPDFListing />}
            />
            <Route
            path="/free-resources/toppers-copies"
            element={<ToppersCopies />}
            />
          <Route path="/free-resources/magazines" element={<Magazines />} /> */}
          {/* <Route
            path="/free-resources/previous-papers"
            element={<PreviousPaper />}
          />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/announcement" element={<Announcement />} /> */}
          {/* <Route path="/blogs" element={<Blogs />} /> */}
          {/* <Route path="/blog/detail" element={<BlogPost />} />
          <Route path="subjectpage" element={<SubjectPage />} /> */}

          <Route
            exact
            path="/course-subscription/:courseName/:courseId/:centerid?"
            element={
              <ProtectedRoute>
                <CourseSubscription />
              </ProtectedRoute>
            }
          />

          {/* ************************************************** Without Login Pages ************************************************** */}

          {/* ************************************************** New Pagee ************************************************** */}
          {/* <Route path="/new-page" element={<NewPage />} /> */}
          <Route path="/course-enquiry" element={<NewPage2 />} />
          {/* ************************************************** Student-Course-Payemnt ************************************************** */}
          <Route
            exact
            path="/course-payments"
            element={<StudentCoursePayments />}
          />
          <Route
            exact
            path="/course-payment-refund"
            element={<StudentCoursePaymentRefunds />}
          />
          <Route
            exact
            path="/verity-or-re-enter-student-account-details"
            element={<VerifyStudentAccountDetails />}
          />

          {/* All static SEO-friendly course URLs -> single CourseDetails component.
              To add/remove a static course URL, edit src/Routing/staticCourseRoutes.js only. */}
          {staticCourseRoutes.map((course) => (
            <Route
              key={course.path}
              path={course.path}
              element={<CourseDetails presetId={course.id} presetName={course.name} />}
            />
          ))}
        </Route>

        <Route exact path="/" element={<NormalHeaderwithoutFooterOutlet />}>
          <Route path="/freeresources" element={<FreeResources />}>
            {/* Free Resources first sections Prelims */}

            <Route path="FRAboutUPSC" element={<FRAboutUPSC />} />
            <Route path="FRAboutUPSCContent" element={<FRAboutUPSCContent />} />
            <Route
              path="FRAboutUPSCEligibility"
              element={<FRAboutUPSCEligibility />}
            />

            <Route path="FRPrelims" element={<FRPrelims />} />
            <Route path="FRPrelimsSyllabus" element={<FRPrelimsSyllabus />} />
            <Route
              path="FRPrelimsPYQPrelims"
              element={<FRPrelimsPYQPrelims />}
            />
            <Route
              path="FRPrelimsPrelimsStrategy"
              element={<FRPrelimsPrelimsStrategy />}
            />
            <Route
              path="FRPrelimsHotTopicsforPrelims"
              element={<FRPrelimsHotTopicsforPrelims />}
            />

            {/* Free Resources second sections Mains */}
            <Route path="FRMains" element={<FRMains />} />
            <Route path="FRMainsSyllabus" element={<FRMainsSyllabus />} />
            <Route path="FRMainsEssay" element={<FRMainsEssay />} />
            <Route path="FRMainsPYQMains" element={<FRMainsPYQMains />} />
            <Route
              path="FRMainsHotTopicsforMains"
              element={<FRMainsHotTopicsforMains />}
            />
            <Route path="FRMainsGS1" element={<FRMainsGS1 />} />
            <Route path="FRMainsGS1Notes" element={<FRMainsGS1Notes />} />
            <Route path="FRMainsGS2Notes" element={<FRMainsGS2Notes />} />
            <Route path="FRMainsGS3Notes" element={<FRMainsGS3Notes />} />
            <Route path="FRMainsGS4Notes" element={<FRMainsGS4Notes />} />
            <Route path="FRMainsGS1Overview" element={<FRMainsGS1Overview />} />
            <Route path="FRMainsGS2Overview" element={<FRMainsGS2Overview />} />
            <Route path="FRMainsGS3Overview" element={<FRMainsGS3Overview />} />
            <Route path="FRMainsGS4Overview" element={<FRMainsGS4Overview />} />
            <Route path="FRMainsGS2" element={<FRMainsGS2 />} />
            <Route path="FRMainsGS3" element={<FRMainsGS3 />} />
            <Route path="FRMainsGS4" element={<FRMainsGS4 />} />
            <Route path="FRMainsPSIR" element={<FRMainsPSIR />} />
            <Route path="FRMainsPSIRPaper1" element={<FRMainsPSIRPaper1 />} />
            <Route path="FRMainsPSIRPaper2" element={<FRMainsPSIRPaper2 />} />

            {/* Free Resources third sections Optional */}
            <Route path="FROptional" element={<FROptional />} />
            <Route path="FROptionalPSIR" element={<FROptionalPSIR />} />
            <Route path="FROptionalHistory" element={<FROptionalHistory />} />
            <Route
              path="FROptionalSociology"
              element={<FROptionalSociology />}
            />
            <Route
              path="FROptionalGeography"
              element={<FROptionalGeography />}
            />

            <Route path="FRInterview" element={<FRInterview />} />
            <Route
              path="FRInterviewToppersInterview"
              element={<FRInterviewToppersInterview />}
            />
            <Route
              path="FRInterviewTopInterviews"
              element={<FRInterviewTopInterviews />}
            />
            <Route
              path="FRInterviewToppersList"
              element={<FRInterviewToppersList />}
            />
            <Route
              path="FRInterviewPanelList"
              element={<FRInterviewPanelList />}
            />
          </Route>
        </Route>

        {/* user header routes */}
        <Route
          exact
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserHeaderOutlet
                courseDrawerShow={courseDrawerShow}
                setCourseDrawerShow={setCourseDrawerShow}
              />
            </ProtectedRoute>
          }
        >
          <Route
            exact
            path="/dashboard/home"
            element={
              <ProtectedRoute>
                <Dashboard
                  courseDrawerShow={courseDrawerShow}
                  setCourseDrawerShow={setCourseDrawerShow}
                />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/profile"
            element={
              <ProtectedRoute>
                <EditProfile />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/book-mentor-appointment"
            element={
              <ProtectedRoute>
                <AppointmentBookingType />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/mentorship-course-selection"
            element={
              <ProtectedRoute>
                <MentorShipCourseSelection />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/student-mentorship-form"
            element={
              <ProtectedRoute>
                <StudentMentorshipForm />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/mentor-selection"
            element={
              <ProtectedRoute>
                <MentorSelection />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/update-user-profile"
            element={
              <ProtectedRoute>
                <UpdateUserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/update-kyc-details"
            element={
              <ProtectedRoute>
                <UpdateKYCDetails />
              </ProtectedRoute>
            }
          />

          {/* <Route
            exact
            path="/dashboard/lecture/:sectionId?"
            element={
              <ProtectedRoute>
                <Lecture />
              </ProtectedRoute>
            }
          /> */}
          <Route
            exact
            path="/dashboard/lecture/:courseid?"
            element={
              <ProtectedRoute>
                <Lecture />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/personalized-lectures"
            element={
              <ProtectedRoute>
                <LectureLayout />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/lecture-notes"
            element={
              <ProtectedRoute>
                <LectureByNotesNew />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard/lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <LectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/personalized-lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <PersonalizedLectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/live-lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <LiveLectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/demand-lecture/detail/:sectionId/:lectureId"
            element={
              <ProtectedRoute>
                <OnDemandLectureDetail />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/test-series"
            element={
              <ProtectedRoute>
                <TestSeries />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/test-series/detail/:testId"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/test-series/detail/:testId/test-overview"
            element={
              <ProtectedRoute>
                <TestResultSummery />
              </ProtectedRoute>
            }
          />

          {/* Postal Course Documents */}

          <Route
            exact
            path="/dashboard/postal-folder-listing"
            element={
              <ProtectedRoute>
                <PostalFolderList />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/new-postal-folder-listing"
            element={
              <ProtectedRoute>
                <NewPostalFolderList />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/postal-folder-listing/:id/"
            element={
              <ProtectedRoute>
                <PostalCourseSubListing />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/new-postal-folder-listing/:id/"
            element={
              <ProtectedRoute>
                <NewPostalFileListing />
              </ProtectedRoute>
            }
          />

          <Route exact path="/dashboard/report" element={<CourseReport />} />
          <Route
            exact
            path="/dashboard/re-upload-answer-sheet"
            element={<ReUploadAnswerSheet />}
          />
          <Route
            exact
            path="/dashboard/my-appointments"
            element={<MyAppointments />}
          />

          <Route
            exact
            path="/dashboard/appointment-detail-page/:id?/:date?"
            element={<AppointmentDetailPage />}
          />
          {/* ************************************ View Student Details ********************************** */}
          <Route
            exact
            path="/dashboard/my-appointments/student-details"
            element={<ViewMentorStudentDetails />}
          />
          <Route
            exact
            path="/dashboard/upcoming-appointments"
            element={<UpcomingAppointments />}
          />

          {/* <Route exact path="/dashboard/videos" element={<ApexLecture />} /> */}
        </Route>

        <Route exact path="/" element={<WithoutHeader />}>
          <Route
            exact
            path="/dashboard/toppers-copies"
            element={<TopperNavigator />}
          />
        </Route>
        <Route exact path="/" element={<WithoutHeader />}>
          <Route
            path="/dashboard/test-series/detail/:testId/test"
            element={<TestUnit />}
          />
        </Route>

        {/* <Route path="/delete-account" element={<DeleteAccount/>} /> */}
        <Route exact path="/" element={<WithoutHeader />}>
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Route>

        <Route exact path="/download-solution" element={<DownloadSolution />} />
        <Route
          path="/civil_services_program"
          element={<CivilServiceProgram />}
        />
      </Routes>
    </section>
  );
};

export default Routing;